import React from "react";
import { useFormik } from "formik";

const ContactSec = () => {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) {
        errors.name = "Name is required";
      }
      if (!values.email) {
        errors.email = "Email is required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address";
      }
      return errors;
    },
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const mailto = `mailto:info@videovision.ae?subject=Contact%20Form%20Submission&body=${encodeURIComponent(
        `Name: ${values.name}\nEmail: ${values.email}\nMessage: ${values.message}`
      )}`;
      window.location.href = mailto;
      setSubmitting(false);
      resetForm();
    },
  });

  return (
    <section className="contact-sec">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-12">
            <div className="contact-wrapper">
              <div className="con-img">
                <img src="/con-img.jpg" alt="contact-img" />
              </div>
              <div className="con-form">
                <h3 className="sec-head white">Get in Touch</h3>
                <p className="para white">
                  Video Vision is a global media technology partner connecting
                  traditional broadcast with the future of digital delivery.
                  With roots in the UAE and the UK, we combine satellite
                  strength, cloud agility, and creative excellence helping our
                  clients distribute content, power communications, and engage
                  audiences everywhere.
                </p>
                <form onSubmit={formik.handleSubmit} autoComplete="off">
                  <div className="row mt-4">
                    <div className="col-lg-6 col-12">
                      <div className="form-group">
                        <label htmlFor="name">Name*</label>
                        <div className="inp-grp">
                          <input
                            id="name"
                            name="name"
                            type="text"
                            placeholder="Enter"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                            className={
                              formik.touched.name && formik.errors.name
                                ? "error"
                                : ""
                            }
                          />
                        </div>
                        {formik.touched.name && formik.errors.name ? (
                          <div className="form-error">{formik.errors.name}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div className="form-group">
                        <label htmlFor="email">Email*</label>
                        <div className="inp-grp">
                          <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Enter"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            className={
                              formik.touched.email && formik.errors.email
                                ? "error"
                                : ""
                            }
                          />
                        </div>
                        {formik.touched.email && formik.errors.email ? (
                          <div className="form-error">
                            {formik.errors.email}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-lg-12 col-12">
                      <div className="form-group">
                        <label htmlFor="message">How Can We Help</label>
                        <div className="inp-grp">
                          <input
                            id="message"
                            name="message"
                            type="text"
                            placeholder="Enter"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.message}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="main-btn red-btn"
                        type="submit"
                        disabled={formik.isSubmitting}
                      >
                        {formik.isSubmitting ? (
                          <span>Submitting...</span>
                        ) : (
                          <span>Submit</span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSec;
